import dayjs from 'dayjs';

/** "Jan 5, 2026, 2:30 PM" — returns em-dash for missing/invalid input. */
export function formatDateTime(iso?: string | null): string {
  if (!iso) return '—';
  const d = dayjs(iso);
  if (!d.isValid()) return '—';
  return d.format('MMM D, YYYY, h:mm A');
}

/** "Jan 5, 2026" */
export function formatDate(iso?: string | null): string {
  if (!iso) return '—';
  const d = dayjs(iso);
  if (!d.isValid()) return '—';
  return d.format('MMM D, YYYY');
}

/** "Signed: Jan 5, 2026 at 2:30 PM" */
export function formatSignatureDate(iso?: string | null): string {
  if (!iso) return '—';
  const d = dayjs(iso);
  if (!d.isValid()) return '—';
  return `Signed: ${d.format('MMM D, YYYY')} at ${d.format('h:mm A')}`;
}
